import API from '@/config/service';
import { useMutation } from '@tanstack/react-query';

// Login mutation hook
export const useSignIn = () => {
  return useMutation({
    mutationFn: async (credentials) => {
      const response = await API.post('/auth/login', credentials);

      // Validate response structure
      if (!response.data?.access_token || !response.data?.user) {
        throw new Error('Invalid authentication response');
      }

      return response.data;
    },
    onSuccess: (data) => {
      // Store tokens securely
      localStorage.setItem('auth_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('user', JSON.stringify(data.user));
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        'Login failed. Please check your credentials.';

      // Clear any invalid tokens
      localStorage.removeItem('auth_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');

      throw new Error(errorMessage);
    }
  });
};

// Logout functionality
export const logout = () => {
  try {
    localStorage.clear();
  } catch { }
  // Navigate to login without keeping current page in history
  if (typeof window !== 'undefined') {
    window.location.assign('/auth/login');
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('auth_token');
};

export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};
